var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatrolInspectionComponent',{attrs:{"typeName":"品質巡回 点検項目設定","type":1,"settionStrageName":"InspectionStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }